import React, { Component } from 'react';
import { observer } from 'mobx-react';
import 'rc-tabs/assets/index.css';
import './command-buffer.scss';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import SwipeableInkTabBar from 'rc-tabs/lib/SwipeableInkTabBar';
import Button from '../../components/button/Button';
import { executeFnByCount } from '../../js/utils';
import { BUFFER_NUM } from '../../mobx/stores/command-buffer';

class CommandBuffer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeKey: '1'
    };
  }

  componentDidMount() {
    // 从本地缓存中读取已缓存的命令区
    // this.props.cmdBufferStore.init();
  }

  onTxtChange(index, value) {
    this.props.cmdBufferStore.buffer[`buffer${index}`] = value;
  }

  onChange = (activeKey) => {
    this.setState({
      activeKey,
    });
  }

  executeCmd(pack) {
    this.props.closePopup();
    this.props.startExecute(this.props.cmdBufferStore.buffer[`buffer${this.state.activeKey}`], pack);
  }

  render() {
    const tabPanes = [];
    executeFnByCount(BUFFER_NUM, (num) => {
      tabPanes.push(
        <TabPane tab={`命令区${num}`} key={num}>
          <textarea
            className="cmd-pane-textarea"
            value={this.props.cmdBufferStore.buffer[`buffer${num}`]}
            onChange={e => this.onTxtChange(num, e.target.value)}
            onKeyUp={e => e.stopPropagation()}
            onBlur={() => window.scrollTo(0, 0)}
          >
          </textarea>
        </TabPane>
      );
    });
    return (
      <div className="cmd-buffer">
        <Tabs
          defaultActiveKey="1"
          tabBarPosition="left"
          activeKey={this.state.activeKey}
          renderTabBar={() => <SwipeableInkTabBar />}
          renderTabContent={() => <TabContent />}
          onChange={this.onChange}
        >
          {tabPanes.reverse()}
        </Tabs>
        <div style={{ textAlign: 'center' }}>
          <Button type="danger" onClick={() => this.props.closePopup()} style={{ marginRight: 20 }}>隐藏</Button>
          <Button type="primary" onClick={() => this.executeCmd()}>执行</Button>
          <Button type="primary" onClick={() => this.executeCmd(true)}>打包执行</Button>
        </div>
      </div>
    );
  }
}

export default observer(CommandBuffer);
